import React, { useEffect } from 'react';
import styles from './OfflineModal.module.scss';

export const OfflineModal: React.FC = () => {
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, []);
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h3 className={styles.title}>Offline</h3>
      </div>
      <div className={styles.content}>
        <div>Please connect to the internet</div>
      </div>
    </div>
  );
};
